import "core-js/modules/es6.string.bold.js";
import React from 'react';
var TypographyContext = /*#__PURE__*/React.createContext(undefined);
export var useTypographyContext = function useTypographyContext() {
  return React.useContext(TypographyContext);
};
export var TypographyContextProvider = function TypographyContextProvider(_ref) {
  var bold = _ref.bold,
      fontFamily = _ref.fontFamily,
      inline = _ref.inline,
      size = _ref.size,
      children = _ref.children;
  var parentTypographyContext = useTypographyContext();
  return /*#__PURE__*/React.createElement(TypographyContext.Provider, {
    value: {
      bold: bold !== null && bold !== void 0 ? bold : parentTypographyContext === null || parentTypographyContext === void 0 ? void 0 : parentTypographyContext.bold,
      fontFamily: fontFamily !== null && fontFamily !== void 0 ? fontFamily : parentTypographyContext === null || parentTypographyContext === void 0 ? void 0 : parentTypographyContext.fontFamily,
      inline: inline !== null && inline !== void 0 ? inline : parentTypographyContext === null || parentTypographyContext === void 0 ? void 0 : parentTypographyContext.inline,
      size: size !== null && size !== void 0 ? size : parentTypographyContext === null || parentTypographyContext === void 0 ? void 0 : parentTypographyContext.size
    }
  }, children);
};
/**
 * Utility function that returns true if this hook is nested inside another
 * typography component, false if otherwise.
 */

export var useIsNestedType = function useIsNestedType() {
  return !!React.useContext(TypographyContext);
};
export var useIsBoldType = function useIsBoldType() {
  var _React$useContext;

  return (_React$useContext = React.useContext(TypographyContext)) === null || _React$useContext === void 0 ? void 0 : _React$useContext.bold;
};